const ROUTES = {
  "/": {
    "name": "HomePage01b053d6Cc6b4446A8d65d66d79a4726",
    "type": "HTML",
    "key": "home-page"
  },
  "/_admin/*": {
    "name": "AdminPages42920e22139541f78b11Cfccafea062d",
    "type": "HTML",
    "key": "admin-pages"
  },
  "/about": {
    "name": "AboutUsPage63e50fdb19354ee0Ad40B4d6b3bd4311",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/about/leveling": {
    "name": "AboutLevelingPageB7f57dea85d94fcbA3808e0616076d1a",
    "type": "HTML",
    "key": "about-leveling-page"
  },
  "/events/public": {
    "name": "PublicEventsPage9145ee0708c54380Adb3483f1a835655",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/join": {
    "name": "JoinUsPage66b3d74d5000499287bf050a85ad6cca",
    "type": "REFERENCE",
    "key": "join-us-page"
  },
  "/members/*": {
    "name": "MemberPages301b0b8280304324A772E738b349e1b2",
    "type": "HTML",
    "key": "member-pages"
  },
  "/members/messages/*": {
    "name": "MessagePages8d91547622b745e1941d6e130611248d",
    "type": "HTML",
    "key": "message-pages"
  },
  "/polytopia-2024": {
    "name": "Polytopia2024C9e3ffb44ecf4540A2cb858ba2782ba4",
    "type": "HTML",
    "key": "polytopia-2024"
  },
  "/polytopia-2024/workshops": {
    "name": "Polytopia2024Workshops4b50699761a3412dBcf75309887e3743",
    "type": "HTML",
    "key": "polytopia-2024-workshops"
  },
  "/polytopia-2025": {
    "name": "Polytopia20253908d6b21d2546f6A8311708917b7a92",
    "type": "HTML",
    "key": "polytopia-2025"
  },
  "/polytopia-2025/handouts": {
    "name": "Polytopia2025Handouts1ac7c8ab0c034635Ae909d9ceefc0042",
    "type": "HTML",
    "key": "polytopia-2025-handouts"
  },
  "/polytopia-2025/presenters": {
    "name": "Polytopia2025Presenters4072249eBada40ffBa9e64dab281acbc",
    "type": "HTML",
    "key": "polytopia-2025-presenters"
  },
  "/polytopia-2025/schedule": {
    "name": "Polytopia2025Schedule64781529D1604d7eA9145a78296a449e",
    "type": "HTML",
    "key": "polytopia-2025-schedule"
  },
  "/polytopia-2025/sponsors": {
    "name": "Polytopia2025Sponsors8c3a11ae70fb4398856942bcd6be18d1",
    "type": "HTML",
    "key": "polytopia-2025-sponsors"
  },
  "/polytopia-2025/workshops": {
    "name": "Polytopia2025WorkshopsF1695465F9cb43fbBd340a8711450b63",
    "type": "HTML",
    "key": "polytopia-2025-workshops"
  },
  "/polytopia-2026": {
    "name": "Polytopia20262394baa1Cb1e48d3Ab02C8c97332f98c",
    "type": "HTML",
    "key": "polytopia-2026"
  },
  "/polytopia-2026/handouts": {
    "name": "Polytopia2026HandoutsDf950adf456f480597ba0f1198c81e87",
    "type": "HTML",
    "key": "polytopia-2026-handouts"
  },
  "/polytopia-2026/presenters": {
    "name": "Polytopia2026PresentersA1c5efd578e14cbb9a6cAbc7c6676c62",
    "type": "HTML",
    "key": "polytopia-2026-presenters"
  },
  "/polytopia-2026/schedule": {
    "name": "Polytopia2026Schedule08dd2a7c03af4d94B901Fbe2d2af471a",
    "type": "HTML",
    "key": "polytopia-2026-schedule"
  },
  "/polytopia-2026/sponsors": {
    "name": "Polytopia2026Sponsors7ee34b5458724ca79dba3aecfdd5e711",
    "type": "HTML",
    "key": "polytopia-2026-sponsors"
  },
  "/polytopia-2026/workshops": {
    "name": "Polytopia2026WorkshopsCc27fbec395044769c3361b66b58ff7b",
    "type": "HTML",
    "key": "polytopia-2026-workshops"
  },
  "/resources": {
    "name": "ResourcesPage7baaf22f8a94416f957eD14924005b83",
    "type": "REFERENCE",
    "key": "resources-page"
  },
  "/signup/*": {
    "name": "SignupPagesE9cede63Cd1f4ab388e718a811b72970",
    "type": "REFERENCE",
    "key": "signup-pages"
  }
};

export default ROUTES;